import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { Stake } from 'app/modules/Betting';
import { mainLineId as mainLineIdSelector } from 'app/modules/LandingPage/MatchOfTheDay/selectors/grid';

import {
  type SortedStakeByStakeTypeGroup, sortedStakeByStakeTypeGroupIdsSelector,
} from '../../selectors';

import styles from './MainStakes.module.scss';

// ---

type StoreProps = {
  sortedStakes: SortedStakeByStakeTypeGroup[];
};

type MainStakesProps = {
  matchId: number;
};

const MainStakes: FC<MainStakesProps & StoreProps> = ({
  matchId,
  sortedStakes,
}) => {
  if (!sortedStakes?.length) {
    return null;
  }

  return (
    <ul className={styles.container}>
      {sortedStakes?.map(({ stakeTypeGroupId, stakeId }) => (
        <li key={`${stakeTypeGroupId}.${stakeId}`}
            className={styles.stakeContainer}>
          <Stake className={styles.stake}
                 disabledIconClassName={styles.disabledIcon}
                 stakeId={stakeId}
                 matchId={matchId} />
        </li>
      ))}
    </ul>
  );
};

const createMapStateToProps = (state: ReduxState, { matchId }: MainStakesProps) => {
  const mainLineId = mainLineIdSelector(state, { matchId });
  const sortedStakeByStakeTypeGroupIds = mainLineId
    && sortedStakeByStakeTypeGroupIdsSelector(state, matchId, mainLineId);
  return {
    sortedStakes: sortedStakeByStakeTypeGroupIds || [],
  };
};


export default connect(createMapStateToProps)(MainStakes);
